// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__32gYW","icon":"SortAdornment_icon__1oh2g","up":"SortAdornment_up__SMlVF","down":"SortAdornment_down__IpZJl","active":"SortAdornment_active__2cXdp"};